/*
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
 */
const RootPath = window.g.baseUrl
const apis = {
  /* 企业管理 */
  GetList: RootPath + 'plugin/user/website/company/GetList',
  getCompany: RootPath + 'plugin/user/website/company/getForm',
  Update: RootPath + 'plugin/user/website/company/Update',
  UpdateApply: RootPath + 'plugin/user/website/company/Delete'
}

export default apis